<template>
    <v-container class="my-10">
        
        <v-row>
            <v-col md="3" sm="12" cols="12">
                <div class="feature d-flex flex-column text-center animate" v-animate-onscroll="'animate__animated  animate__bounceInUp '">
                    <div>
                        <v-icon
                            size="56"
                            color="orange"
                            >
                            mdi-android
                        </v-icon>
                    </div>
                    <div>
                        <h1 class="text-h5 font-weight-black">Branded Android App</h1>
                    </div>
                    <div>
                        <p>
                            Get android app with your own brand name on play store.
                        </p>
                    </div>
                </div>
            </v-col>
            <v-col md="3" sm="12" cols="12">
                <div class="feature d-flex flex-column text-center animate" v-animate-onscroll="'animate__animated  animate__bounceInUp '">
                    <div>
                        <v-icon
                            size="56"
                            color="orange"
                            >
                            mdi-currency-inr
                        </v-icon>
                    </div>
                    <div>
                        <h1 class="text-h5 font-weight-black">Time & Cost Efficient</h1>
                    </div>
                    <div>
                        <p>
                            Start your business at Rs. 4999/- only within 24hrs.
                        </p>
                    </div>
                </div>
            </v-col>
            <v-col md="3" sm="12" cols="12">
                <div class="feature d-flex flex-column text-center animate" v-animate-onscroll="'animate__animated  animate__bounceInUp '">
                    <div>
                        <v-icon
                            size="56"
                            color="orange"
                            >
                            mdi-credit-card
                        </v-icon>
                    </div>
                    <div>
                        <h1 class="text-h5 font-weight-black">Seamless Payments</h1>
                    </div>
                    <div>
                        <p>
                            Both User and dlivery app are equiped with highly secure and fast payment gateway.
                        </p>
                    </div>
                </div>
            </v-col>
            <v-col md="3" sm="12" cols="12" >
                <div class="feature d-flex flex-column text-center animate" v-animate-onscroll="'animate__animated  animate__bounceInUp '">
                    <div>
                        <v-icon
                            size="56"
                            color="orange"
                            >
                            mdi-infinity
                        </v-icon>
                    </div>
                    <div>
                        <h1 class="text-h5 font-weight-black">No Capping</h1>
                    </div>
                    <div>
                        <p>
                           Our all plans includes unlimited orders, products and users.
                        </p>
                    </div>
                </div>
            </v-col>
            
        </v-row>
    
    </v-container>
</template>
<script type="text/javascript" scoped>
    export default{

    }
</script>